"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _httpCore = require("@webex/http-core");
var _kmsErrors = require("./kms-errors");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Interceptor (only to be used in test mode) intended to replay requests that
 * fail as a result of the test-user incompatibility in KMS.
 * @class
 */
var KmsDryErrorInterceptor = /*#__PURE__*/function (_Interceptor) {
  (0, _inherits2.default)(KmsDryErrorInterceptor, _Interceptor);
  var _super = _createSuper(KmsDryErrorInterceptor);
  function KmsDryErrorInterceptor() {
    (0, _classCallCheck2.default)(this, KmsDryErrorInterceptor);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(KmsDryErrorInterceptor, [{
    key: "onResponseError",
    value:
    /**
     * @param {Object} options
     * @param {Exception} reason
     * @returns {Promise}
     */
    function onResponseError(options, reason) {
      if (reason instanceof _kmsErrors.DryError && reason.message.match(/Failed to resolve authorization token in KmsMessage request for user/)) {
        this.webex.logger.error('DRY Request Failed due to kms/test-user flakiness');
        this.webex.logger.error(reason);
        return this.replay(options, reason);
      }
      return _promise.default.reject(reason);
    }

    /**
     * Replays the request
     * @param {Object} options
     * @param {DryError} reason
     * @returns {Object}
     */
  }, {
    key: "replay",
    value: function replay(options, reason) {
      if (options.replayCount) {
        options.replayCount += 1;
      } else {
        options.replayCount = 1;
      }
      if (options.replayCount > this.webex.config.maxAuthenticationReplays) {
        this.webex.logger.error("kms: failed after ".concat(this.webex.config.maxAuthenticationReplays, " replay attempts"));
        return _promise.default.reject(reason);
      }
      this.webex.logger.info("kms: replaying request ".concat(options.replayCount, " time"));
      return this.webex.request(options);
    }
  }], [{
    key: "create",
    value:
    /**
     * @returns {KmsDryErrorInterceptor}
     */
    function create() {
      return new KmsDryErrorInterceptor({
        webex: this
      });
    }
  }]);
  return KmsDryErrorInterceptor;
}(_httpCore.Interceptor);
exports.default = KmsDryErrorInterceptor;
//# sourceMappingURL=kms-dry-error-interceptor.js.map
